import useSWR from 'swr';
import server from '../services/server';
import useErrors from './useErrors';

export function useFetch(url, params, options={}) {
    const { setErrors } = useErrors();
    const { data, error, mutate, isLoading, isValidating } = useSWR(
        { url, params  },
        
        async ({ url, params }) => {
            const response = await server.get(url, params);

            return response?.data;
        },
        {
            errorRetryCount: 2,
            errorRetryInterval: 50000,
            ...options
        },
    );
    if (error) {
        setErrors(error);
    }

    return { data: data, error, mutate, isFetching: !data && !error, isLoading, isValidating };
}
